import React from "react";
import { AlertLineReportDTO } from "../../../models/alert-line-report/alert-line-report-dto";
import AlertLineReportDetails from "../AlertLineReportDetails";
import AlertLinePageHeader from "../../../views/alert-line-report/AlertLinePage/AlertLinePageHeader";
import { Container } from "./styles";
import { Grid } from "@mui/material";
import AlertLineReportNotes from "../../AlertLineReportNotes/AlertLineReportNotes";
import { AlertLineReportNoteDTO } from "../../../models/alert-line-report-note/alert-line-report-note-dto";

interface Props {
  alertLineReport: AlertLineReportDTO;
  allNotes?: AlertLineReportNoteDTO[];
}

const ExportedAlertLineReport = ({ alertLineReport, allNotes }: Props) => {
  return (
    <Container>
      <AlertLinePageHeader
        alertLineURLId={alertLineReport.alertLineURL?.id}
        previousReport={alertLineReport}
      />
      <Grid style={{ padding: "10px" }}>
        <AlertLineReportDetails
          alertLineReport={alertLineReport}
          forExport
        />
        <br />
        <AlertLineReportNotes
          allNotes={allNotes}
          alertLineReport={alertLineReport}
          forExport
        />
      </Grid>
    </Container>
  );
};
export default ExportedAlertLineReport;
